import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../styled';
import { PdfDefault } from '../../Icons';
export const Style = styled.div `
  padding-top: 8px;
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  .pdf-icon {
    width: 25px;
    height: auto;
    margin-right: 9px;
  }
  overflow: hidden;
  word-break: break-word;
`;
export const Name = styled.p `
  margin: 0;
  font-weight: ${(props) => props.theme.bold};
  font-size: ${(props) => props.theme.fontNormal};
`;
export const Description = styled.p `
  color: ${theme.darkGray};
  font-size: ${(props) => props.theme.fontSmall};
  margin: 0;
`;
const Title = ({ name, description }) => (React.createElement(Style, { className: "document-title" },
    React.createElement(PdfDefault, { className: "pdf-icon" }),
    React.createElement("div", null,
        React.createElement(Name, { className: "document-name" }, name),
        React.createElement(Description, { className: "document-description" }, description))));
export default Title;
